import { DeleteOutlined } from '@ant-design/icons';
import { styled } from '@stitches/configed';
import { Button, message, Space, Upload as UploadAnt } from 'antd';
import { RcFile } from 'antd/lib/upload';
import { useEffect, useState } from 'react';
import { uploadImage } from '../../../services/attachment';
import { Image } from '../Image';
import { CropOrNotWrapper } from './CronOrNotWrapper';
import EmptyPng from './empty.png';


const UploadWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  '@xs': {
    flexDirection: 'row',
  },

  '& > div + div': {
    marginTop: 16,
    '@xs': {
      marginTop: 0,
      marginLeft: 16,
    },
  },
});
const ButtonUpload = styled(Button, {
  marginBottom: 16,
  width: 200,
  color: '#fff !important',
  backgroundColor: '#2844CE !important',
  borderColor: '#2844CE !important',
  '&:hover': {
    color: '#fff !important',
    backgroundColor: '#1c2799 !important',
    borderColor: '#1a248e !important',
  },
});

const ImagePreviewWrapperStyled = styled('div', {
  width: '100%',
  height: 'fit-content',
  display: 'flex',
  justifyContent: 'center',
  '@xs': {
    width: 'auto',
  },
  gap: 10
});
type Props = {
  role: 'customer' | 'shipper' | 'merchant' | 'admin';
  crop?: boolean | { width: number; height: number };
  loading?: boolean;
  onUploadSuccess?: (imageUrls: string[]) => void;
  onUploadding?: () => void;
  onUploadFinished?: () => void;
  onChose?: (file: RcFile, imageUrl: string) => void;
  onRemove: () => void;
  onError?: (errors: string[]) => void;
  initialValue?: null | string[];
  width?: number;
  height?: number;
  description?: any;
  disable?: boolean;

  accept?: string;
  fileSize?: number | false;
  fixedWidth?: boolean;
};
const UploadMultiImage = ({
  role,
  crop,
  loading,
  initialValue,
  width,
  height,
  onUploadSuccess,
  onUploadding,
  onUploadFinished,
  onChose,
  onRemove,
  onError,
  description,
  disable = false,

  accept = '.jpg,.jpeg,.png,.svg',
  fileSize = 2,
  fixedWidth,
}: Props) => {
  const [isLoading, setIsLoading] = useState(false);

  const [files, setFiles] = useState<string[]>();
  const beforeUploadMultiple = async (file: RcFile, fileList: RcFile[]) => {
    fileList.forEach((file) => {
      if (fileSize && file.size > fileSize * 1024 * 1024) {
        if (onError) {
          onError([`Hình ảnh phải nhỏ hơn ${fileSize}MB!`]);
        } else {
          message.error(`Hình ảnh phải nhỏ hơn ${fileSize}MB!`);
        }
        return false;
      }
    });

    try {
      const uploadPromise = async (file: RcFile) => {
        const formData = new FormData();
        formData.append('file', file);
        const result = await uploadImage(role, formData);
        return result.data.data.url;
      };
      const promises = fileList.map((file) => uploadPromise(file));

      if (onUploadSuccess) {
        setIsLoading(true);
        onUploadding && onUploadding(); // parent
        const results = await Promise.all(promises);
        setFiles(results);
        onUploadSuccess(results);
       
      }
    } catch (error) {
      setFiles([]);
      message.error('Đã xảy ra lỗi, vui lòng kiểm tra lại!');
    } finally {
      setIsLoading(false);
      onUploadFinished && onUploadFinished(); // parent
    }
    return false;
  };

  useEffect(() => {
    if (initialValue && initialValue.length > 0) {
      setFiles(initialValue);
    }
  }, [initialValue]);
  return (
    <UploadWrapper>
      <ImagePreviewWrapperStyled>
        {files && files.length > 0 ? (
          files.map((file, index) => (
            <Image
              key={index}
              src={file ? file : EmptyPng}
              style={{
                objectFit: 'cover',
                height: height || 200,
                width: fixedWidth ? width : width && height && height !== 200 ? width / (height / 200) : 200, // convert width follow default height
                borderRadius: 10,
              }}
            />
          ))
        ) : (
          <Image
            src={EmptyPng}
            style={{
              objectFit: 'cover',
              height: height || 200,
              width: fixedWidth ? width : width && height && height !== 200 ? width / (height / 200) : 200, // convert width follow default height
              borderRadius: 10,
            }}
          />
        )}
      </ImagePreviewWrapperStyled>
      <Space align="start" direction="vertical">
        <CropOrNotWrapper
          enable={!!crop}
          width={typeof crop === 'object' ? crop.width : width}
          height={typeof crop === 'object' ? crop.height : height}
        >
          <UploadAnt accept={accept} showUploadList={false} beforeUpload={beforeUploadMultiple}
          multiple
          >
            <ButtonUpload loading={isLoading || loading} disabled={isLoading || disable}>
              Tải ảnh
            </ButtonUpload>
          </UploadAnt>
        </CropOrNotWrapper>
        {files && files.length > 0 && (
          <Button
            className="light danger"
            style={{ width: 200 }}
            icon={<DeleteOutlined />}
            onClick={() => {
              onRemove();
              setFiles([]);
            }}
            disabled={disable}
          >
            Xoá ảnh
          </Button>
        )}
        <div>
          {description ? (
            description
          ) : (
            <>
              <div>
                - {width && height ? `Kích thước ảnh ${Math.round((width / height) * 100) / 100}:1` : 'Ảnh khổ vuông'}
              </div>
              <div>- Dung lượng tối đa 2MB</div>
              <div>- Định dạng .jpg, .png</div>
            </>
          )}
        </div>
      </Space>
    </UploadWrapper>
  );
};

export default UploadMultiImage;
